import { CommonModule } from '@angular/common';
import { Component, input, model, OnDestroy, OnInit, output } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { Subscription } from 'rxjs';
import { ModalService } from 'src/app/core/services/modal.service';
import { defaultCustomButtonDto } from 'src/app/shared/components/app-button/app-button-dto';
import { AppButtonComponent } from 'src/app/shared/components/app-button/app-button.component';
import { AppInputComponent, InputType } from 'src/app/shared/components/app-input/app-input.component';

declare var bootstrap: any;

@Component({
  selector: 'app-modal-select-coupon',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    AppInputComponent,
    AppButtonComponent
  ],
  templateUrl: './modal-select-coupon.component.html',
  styleUrl: './modal-select-coupon.component.scss'
})
export class ModalSelectCouponComponent implements OnInit, OnDestroy {

  modalId = input.required<string>();
  couponOptions = input.required<any>();
  couponFormGroup = input.required<FormGroup>();
  memberCoupons = input.required<any[]>();
  InputTypeEnum = InputType;

  confirmAction = output<{ coupon: string }>();
  private modalSubscription: Subscription | undefined;

  public styles: { [key: string]: string };

  constructor(
    private modalService: ModalService,
  ) { }

  ngOnInit(): void {
    this.modalSubscription = this.modalService.modalState$.subscribe(
      (state) => {
        if (state.id === this.modalId()) {
          const modalElement = document.getElementById(state.id);
          if (modalElement) {
            if (state.action === 'open') {
              const modal = new bootstrap.Modal(modalElement);

              modal.show();

              this.couponOptions().primaryColor = this.couponOptions()?.primaryColor ?? defaultCustomButtonDto?.primaryColor;
              this.couponOptions().secondaryColor = this.couponOptions()?.secondaryColor ?? defaultCustomButtonDto?.secondaryColor;
              this.styles = {
                '--primaryColor': this.couponOptions()?.primaryColor as string
              }
            } else if (state.action === 'close') {
              const modal = bootstrap.Modal.getInstance(modalElement);
              if (modal) {
                modal.hide();
              }
            }
          }
        }
      }
    );
  }

  transformCouponToUppercase(): void {
    const couponControl = this.couponFormGroup().get('coupon');
    if (couponControl && couponControl.value) {
      couponControl.setValue(couponControl.value.toUpperCase(), { emitEvent: false });
    }
  }

  getValidity(coupon: any): string {
    if (!coupon?.validity) {
      return 'Sem data de validade';
    }

    return `Válido até ${String(coupon.validity).split('T')[0].split('-').reverse().join('/')}`;
  }

  onConfirm(coupon: string) {
    this.confirmAction.emit({ coupon });
    this.modalService.close(this.modalId());
  }

  get controls(): any {
    return this.couponFormGroup().controls;
  }

  ngOnDestroy(): void {
    if (this.modalSubscription) {
      this.modalSubscription.unsubscribe();
    }
  }

}
